export const useGlobalI18n = () => {
  try {
    // If the current instance is not available, fallback to the Nuxt app's i18n instance
    // ref: https://github.com/intlify/vue-i18n/blob/master/packages/vue-i18n-core/src/i18n.ts
    if (getCurrentInstance() === null) return useNuxtApp().$i18n

    return useI18n()
  } catch (error) {
    console.error('useGlobalI18n error:', error)
    return useNuxtApp().$i18n
  }
}
